







































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import _ from 'lodash'
import { displayColorCalculoRecebimentoBySituation, timeoutDefault, maskDateTime, maskDate, onlyNumber } from '@/utils/common'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import { IRequestMessage, RequestMessage, SituacaoRemuneracaoCalculadoEnum, DataTablePagination } from '@/types/_'

@Component
export default class ViewFinanceiroCalculoRemuneracao extends Vue {
  $refs!: {
    formTabelaDeSenioridade: any
    menuTabelaDeSenioridade: any
  }

  getRequestMessage: IRequestMessage = new RequestMessage()
  modalTabelaDeSenioridade: boolean = false
  menuTabelaDeSenioridade: boolean = false
  loadValidarRepasse: boolean = false
  loadDescartarRepasse: boolean = false
  loadValidarRepasseSelecionados: boolean = false
  loadDescartarRepasseSelecionados: boolean = false
  modalInformarCodigoAmb: boolean = false
  loadItemsValidacao: boolean = false
  loadSalvarCodigo: boolean = false
  loadInformarCodigoAmb: string = ''
  modalValidar: boolean = false
  modalValidarSelecionados: boolean = false
  exp: boolean = false
  codigo: string = ''
  operadoraIdValidar: string = ''
  sel: any[] = []

  get selected() { return this.sel }
  set selected(value: any) { this.sel = value }

  get getPagina() {
    return this.getFinanceiroStore.pagina
  }

  set getPagina(value: number) {
    this.getFinanceiroStore.setPagina(value)
  }

  get showModalValidar() {
    return this.modalValidar
  }

  set showModalValidar(value: boolean) {
    this.modalValidar = value
  }

  get showModalValidarSelecionados() {
    return this.modalValidarSelecionados
  }

  set showModalValidarSelecionados(value: boolean) {
    this.modalValidar = value
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get headersTabelaValidacao() {
    return this.getFinanceiroStore.headersTabelaValidacao
  }

  get headersTabelaDeSenioridade() {
    return this.getFinanceiroStore.headersTabelaDeSenioridade
  }

  get codigoAmb() {
    return this.codigo
  }

  set codigoAmb(value: string) {
    this.codigo = value
  }

  get expand() {
    return this.exp
  }

  set expand(value: boolean) {
    this.exp = value
  }

  get drawer() {
    return this.getFinanceiroStore.filterDrawer
  }

  set drawer(value: boolean) {
    this.getFinanceiroStore.setFilterDrawer(value)
  }

  get profissional() {
    return this.getFinanceiroStore.profissionaisExecutantes
  }

  set profissional(value: any) {
    this.getFinanceiroStore.profissionaisExecutantes = value
  }

  get convenio() {
    return this.getFinanceiroStore.convenio
  }

  set convenio(value: any) {
    this.getFinanceiroStore.convenio = value
  }

  get profissionais() {
    return this.getFinanceiroStore.profissionais
  }

  set profissionais(value: any) {
    this.getFinanceiroStore.setProfissionais(value)
  }

  get convenios() {
    return this.getFinanceiroStore.convenios
  }

  set convenios(value: any) {
    this.getFinanceiroStore.setConvenios(value)
  }

  get operadoraId() {
    return this.getFinanceiroStore.operadoraId
  }

  set operadoraId(value: any) {
    this.getFinanceiroStore.setOperadoraId(value)
  }

  get situacao() {
    return this.getFinanceiroStore.situacoesValidacao
  }

  set situacao(value: any) {
    this.getFinanceiroStore.setSituacoesValidacao(value.key)
  }

  get erros() {
    return this.getFinanceiroStore.errosValidacao
  }

  set erros(value: any) {
    this.getFinanceiroStore.setErrosValidacao(value.key)
  }

  get itemsTabelaValidacao() {
    return this.getFinanceiroStore.itemsTabelaValidacao
  }

  get situacoesValidacao() {
    return [
      { key: 'Calculado', display: 'Calculado' },
      { key: 'Validado', display: 'Validado' },
      { key: 'Divergente', display: 'Divergente' },
      { key: 'Descartado', display: 'Descartado' },
    ]
  }

  get errosValidacao() {
    return [
      { key: 'VariosCodigosProcedimento', display: 'Vários códigos de procedimento' },
      { key: 'CodigoRegraNaoEncontrado', display: 'Código de regra não encontrado' },
      { key: 'TabelaBaseNaoEncontrada', display: 'Tabela base não encontrada' },
      { key: 'ValorTabelaBaseNaoEncontrado', display: 'Valor da tabela base não encontrada' },
      { key: 'GrupoProcedimentoNaoEncontrado', display: 'Grupo de procedimento não encontrado' },
      { key: 'RegraNaoEncontrada', display: 'Regra não encontrada' },
      { key: 'ValorIndiceNaoEncontrado', display: 'Valor índice não encontrado' },
    ]
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  get loadingValidarRepasse() {
    return this.loadValidarRepasse
  }

  set loadingValidarRepasse(value: boolean) {
    this.loadValidarRepasse = value
  }

  get loadingDescartarRepasse() {
    return this.loadDescartarRepasse
  }

  set loadingDescartarRepasse(value: boolean) {
    this.loadDescartarRepasse = value
  }

  get loadingValidarRepasseSelecionados() {
    return this.loadValidarRepasseSelecionados
  }

  set loadingValidarRepasseSelecionados(value: boolean) {
    this.loadValidarRepasseSelecionados = value
  }

  get loadingDescartarRepasseSelecionados() {
    return this.loadDescartarRepasseSelecionados
  }

  set loadingDescartarRepasseSelecionados(value: boolean) {
    this.loadDescartarRepasseSelecionados = value
  }

  get loadingItemsValidacao() {
    return this.loadItemsValidacao
  }

  set loadingItemsValidacao(value: boolean) {
    this.loadItemsValidacao = value
  }

  get loadingSalvarCodigo() {
    return this.loadSalvarCodigo
  }

  set loadingSalvarCodigo(value: boolean) {
    this.loadSalvarCodigo = value
  }

  get loadingInformarCodigoAmb() {
    return this.loadInformarCodigoAmb
  }

  set loadingInformarCodigoAmb(value: string) {
    this.loadInformarCodigoAmb = value
  }

  get getTotal() {
    return this.getFinanceiroStore.itemsTabelaValidacaoTotal || 0
  }

  get itemsValidacaoLength() {
    return Math.ceil(this.getTotal / this.getFinanceiroStore.qtdPorPagina)
  }

  closeModalInformarCodigoAmb() {
    this.modalInformarCodigoAmb = false
    this.codigoAmb = ''
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  async salvarCodigo(id: string) {
    this.loadingSalvarCodigo = true
    if (this.codigoAmb) {
      this.getFinanceiroStore.setCodigoAMB(this.codigoAmb)
      this.getFinanceiroStore.setMedicoProducaoProcedimentoId(id)
      await this.getFinanceiroStore.salvarCodigoAmb()
      this.closeModalInformarCodigoAmb()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: 'Este campo é de preenchimento obrigatório.', icon: 'warning', color: '#C62828' })
    }
    this.loadingSalvarCodigo = false
  }

  async showModalInformarCodigoAmb(id: any) {
    this.loadingInformarCodigoAmb = id
    await timeoutDefault()
    this.modalInformarCodigoAmb = true
    this.loadingInformarCodigoAmb = ''
  }

  async clearAdvancedFilters() {
    this.getFinanceiroStore.clearFiltroValidacao()
    this.getFinanceiroStore.setFilterOn(false)
    this.getFinanceiroStore.clearPagePagination()
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    await this.getFinanceiroStore.getRegistrosValidacao()
    EventBus.$emit('clearLoadingRequest')
  }

  async validarRepasses() {
    this.loadingValidarRepasse = true
    const params: any = {
      medicoRecebimentoIds: [this.operadoraIdValidar],
      situacao: 'Validado',
    }
    const response = await this.getFinanceiroStore.validarRepasses(params)
    if (response.success) {
      await this.getFinanceiroStore.getRegistrosValidacao()
      this.closeModalValidar()
      EventBus.$emit('setSnackbar', { show: true, text: 'Validação efetuada com sucesso!', icon: 'done', color: '#2E7D32' })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }
    this.loadingValidarRepasse = false
  }

  async descartarRepasses() {
    this.loadingDescartarRepasse = true
    const params: any = {
      medicoRecebimentoIds: [this.operadoraIdValidar],
      situacao: 'Descartado',
    }
    const response = await this.getFinanceiroStore.validarRepasses(params)
    if (response.success) {
      await this.getFinanceiroStore.getRegistrosValidacao()
      this.closeModalValidar()
      EventBus.$emit('setSnackbar', { show: true, text: 'Validação efetuada com sucesso!', icon: 'done', color: '#2E7D32' })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }
    this.loadingDescartarRepasse = false
  }

  async validarRepassesSelecionados() {
    this.loadingValidarRepasseSelecionados = true
    const params: any = {
      medicoRecebimentoIds: this.selected = this.itemsTabelaValidacao.map((e: any) => {
        const i = e
        return i.medicoRecebimentoIdPrincipal
      }),
      situacao: 'Validado',
    }
    const response = await this.getFinanceiroStore.validarRepasses(params)
    if (response.success) {
      await this.getFinanceiroStore.getRegistrosValidacao()
      this.closeModalValidarSelecionados()
      EventBus.$emit('setSnackbar', { show: true, text: 'Validação efetuada com sucesso!', icon: 'done', color: '#2E7D32' })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }
    this.loadingValidarRepasseSelecionados = false
  }

  async descartarRepassesSelecionados() {
    this.loadingDescartarRepasseSelecionados = true
    const params: any = {
      medicoRecebimentoIds: this.selected = this.itemsTabelaValidacao.map((e: any) => {
        const i = e
        return i.medicoRecebimentoIdPrincipal
      }),
      situacao: 'Descartado',
    }
    const response = await this.getFinanceiroStore.validarRepasses(params)
    if (response.success) {
      await this.getFinanceiroStore.getRegistrosValidacao()
      this.closeModalValidarSelecionados()
      EventBus.$emit('setSnackbar', { show: true, text: 'Validação efetuada com sucesso!', icon: 'done', color: '#2E7D32' })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }
    this.loadingDescartarRepasseSelecionados = false
  }

  openModalValidar(id: string) {
    this.operadoraIdValidar = id
    this.modalValidar = true
  }

  openModalValidarSelecionados(id: string) {
    this.operadoraIdValidar = id
    this.modalValidarSelecionados = true
  }

  closeModalValidar() {
    this.modalValidar = false
  }

  closeModalValidarSelecionados() {
    this.modalValidarSelecionados = false
  }

  formatDateTime(date: string) {
    return maskDateTime(date)
  }

  formatDate(date: string) {
    return maskDate(date)
  }

  formatMoney(value) {
    if (['', 0, null, undefined].includes(value)) return 'R$ -'
    // eslint-disable-next-line
    if (isNaN(value)) return 'R$ -'
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(+value)
  }

  formatDecimal(value) {
    if (['', 0, null, undefined].includes(value)) return '0'
    // eslint-disable-next-line
    if (isNaN(value)) return '0'
    return new Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits: 4 }).format(+value)
  }

  displayCorSituacao(value: string) {
    return displayColorCalculoRecebimentoBySituation(value)
  }

  displayCorErros(value: string) {
    switch (value) {
      case 'VariosCodigosProcedimento':
        return { background: 'deep-orange lighten-5', text: 'deep-orange darken-5' }
      case 'CodigoRegraNaoEncontrado':
        return { background: 'red lighten-5', text: 'red darken-2' }
      case 'TabelaBaseNaoEncontrada':
        return { background: 'deep-orange lighten-5', text: 'deep-orange darken-5' }
      case 'ValorTabelaBaseNaoEncontrado':
        return { background: 'red lighten-5', text: 'red darken-2' }
      case 'GrupoProcedimentoNaoEncontrado':
        return { background: 'deep-orange lighten-5', text: 'deep-orange darken-5' }
      case 'RegraNaoEncontrada':
        return { background: 'red lighten-5', text: 'red darken-2' }
      case 'ValorIndiceNaoEncontrado':
        return { background: 'deep-orange lighten-5', text: 'deep-orange darken-5' }
      default:
        return { background: '', text: '' }
    }
  }

  async selectSituacao(item: any) {
    this.situacao = item
    await this.$nextTick(() => {
      this.filter()
    })
  }

  async selectErros(item: any) {
    this.erros = item
    await this.$nextTick(() => {
      this.filter()
    })
  }

  async selectConvenio(item: any) {
    this.operadoraId = item
    await this.$nextTick(() => {
      this.filter()
    })
  }

  async selectProfissional(item: string) {
    this.profissionais = item
    await this.$nextTick(() => {
      this.filter()
    })
  }

  async filter() {
    this.getFinanceiroStore.clearPagePagination()
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    await this.getFinanceiroStore.getRegistrosValidacao()
    EventBus.$emit('clearLoadingRequest')
  }

  async showAdvancedFilters() {
    this.drawer = !this.drawer
  }

  toggleAll() {
    if (this.selected.length > 0) {
      this.selected = []
    } else {
      this.selected = this.itemsTabelaValidacao.map((e: any) => {
        const i = e
        return i.medicoProducaoProcedimentoId
      })
    }
  }

  async getResults(pagina: number) {
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    this.getPagina = pagina
    await this.getFinanceiroStore.getRegistrosValidacao()
    EventBus.$emit('clearLoadingRequest')
  }

  async updatePagination(pagination: DataTablePagination) {
    this.loadingItemsValidacao = true
    let param = ''
    if (pagination.sortBy) {
      param = pagination.descending ? `${pagination.sortBy}Desc` : `${pagination.sortBy}Asc`
    } else {
      param = ''
    }
    this.getFinanceiroStore.setSortBy(param)
    await this.getFinanceiroStore.getRegistrosValidacao()
    this.loadingItemsValidacao = false
  }

  async init() {
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    await this.getFinanceiroStore.clearFiltroValidacao()
    await this.getFinanceiroStore.getProfissionais()
    await this.getFinanceiroStore.getConvenio()
    await this.getFinanceiroStore.getFontePagadoraAll()
    EventBus.$emit('clearLoadingRequest')
  }

  async mounted() {
    await this.init()
  }
}
